<template>
  <div class="about">
    <div class="banner outer">
      <div class="inside">
        <div class="companybox">易猎云（海南）科技有限公司</div>
        <p class="comtext">国内领先的RPO企业招聘数字化解决方案提供商</p>
      </div>
    </div>
    <div class="introduce outer">
      <div class="title_s">
        <div>
          <router-link to="/about"  active-class="actives">公司介绍</router-link>
          <router-link to="/media" active-class="actives">媒体报道</router-link>
          <!-- <a :href="[`${path}/about${rou}`]" class="actives">公司介绍</a>-->
          <!-- <a :href="[`${path}/media${rou}`]">媒体报道</a>  -->
        </div>
      </div>
      <div class="inside" style="height: max-content">
        <div class="introducetext">
          <h3>公司介绍</h3>
          <p class="text1">
            易猎云，中国领先的RPO企业招聘管理系统综合解决方案供应商，以“招聘数字化”为使命，将先进的数字化管理理念融入招聘管理系统，做到招聘流程可视化、数字化、智能化，通过技术和服务赋能RPO招聘企业。
          </p>
          <p class="text2">
            易猎云一直奉行“技术驱动，产品领先”的经营理念，从成立之初就聚集国内相关领域的顶尖人才，如智联、北森、BOSS直聘、BAT等知名企业，通过长期的技术投入和产品迭代，积累了完整成熟的产品矩阵，包括易猎招聘管理系统、易享员工服务系统、易猎职享等产品，产品之间实现了相互打通，全流程业务无缝衔接。迄今为止，累计服务客户包括位来小猎、陕西易通、熊猫云聘、点米科技、勇晖集团等500余家客户。
          </p>
          <p class="text3">
            未来，易猎云将继续深耕RPO批量招聘及HRO领域，将先进的技术与在批量基础岗位招聘、小微人力资源企业数字化建设等方面积累的业务实践经验结合起来，打造国内RPO招聘领域的第一品牌，助力更多国内外人力资源企业实现数字化升级和改造。
          </p>
        </div>
      </div>
    </div>
    <div style="height: 40px; background: #e7f2ff"></div>
    <div class="ontrial outer">
      <div class="inside">
        <h3>即刻开启数字化招聘人效提升之旅</h3>
        <p @click="trial">申请试用</p>
      </div>
    </div>
    <!--申请试用组件-->
    <populone :isshow="windowflag" :he="true" @handleChange="changewindow" />
  </div>
</template>
<script>
import populone from "@/components/views/popul/populone.vue";

export default {
  name: "about",
  data() {
    return {
      routeData:{},
      actives: 1,
      windowflag: false,
      URl: "",
      rou: "",
      path:'https://www.yilieyun.com'
    };
  },
  components: {
    populone,
  },
  metaInfo: {
    title: "关于易猎云-更适合RPO的免费招聘管理系统",
    meta: [
      {
        name: "keywords",
        content: "易猎云，易猎云海南，易猎云招聘，招聘管理系统，RPO批量招聘",
      },
      {
        name: "description",
        content: "易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统",
      },
    ],
  },
  mounted() {
    this.URl = window.location.origin;
    if (window.location.href.split("?")[1])
      this.rou = `?${window.location.href.split("?")[1]}`;
      console.log(this.rou);
    if (this.$route.params.identification) this.actives = 2;
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    const { u = "" } = this.routeData;
    if (!u) {
      console.log("关于我们");
      zhuge.track("官网关于我们", {
        渠道: "pc",
        utm类型: "自然流量",
      });
    } else {
      zhuge.track("官网关于我们", {
        渠道: "pc",
        utm类型: "驱动流量",
      });
    }
  },
  methods: {
    lefts() {
      this.actives = 1;
    },
    rights() {
      this.actives = 2;
    },
    trial() {
      this.windowflag = true;
    },
    changewindow(value) {
      this.windowflag = value;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";

.title_s {
  display: flex;
  justify-content: center;

  div {
    display: flex;
  }

  a {
    cursor: pointer;
    font-size: 36px;
    color: #1d2754;
    line-height: 80px;
    margin: 20px;
  }

  .actives {
    border-bottom: 3px solid #0084ff;
  }
}

.meiti {
  margin-bottom: 40px;

  a {
    display: block;
    font-size: 24px;
    margin: 0;
    color: #1d2754;
    font-weight: 800;
    line-height: 50px;
    cursor: pointer;
  }

  a:hover {
    /*color: #5666ff;*/
  }

  p:nth-of-type(1) {
    font-size: 22px;
    font-weight: 500;
    color: #686d85;
    line-height: 30px;
    margin-left: 25px;
  }

  p:nth-of-type(2) {
    font-size: 22px;
    font-weight: 500;
    color: #686d85;
    line-height: 30px;
    float: right;
    cursor: pointer;
  }
}

.about {
  margin-top: 105px;

  .banner {
    width: 100%;
    height: 504px;
    background-image: url("https://yilie.oss-cn-beijing.aliyuncs.com/front-yilieyun/official/lQLPJxZc3D83uM_NA_DNDwCwK9IfiCi3W6YCmTVsOoCdAA_3840_1008.png");
    background-repeat: no-repeat;
    background-size: 105%;
    padding-top: 133px;

    .companybox {
      width: 596px;
      height: 93px;
      background: #1990ff;
      margin-left: 26px;
      font-size: 36px;
      font-weight: 600;
      color: #ffffff;
      line-height: 93px;
      text-align: center;
    }

    .comtext {
      width: 790px;
      height: 165px;
      font-size: 34px;
      font-weight: 500;
      color: #1d2754;
      line-height: 55px;
      margin-left: 26px;
      margin-top: 34px;
    }
  }

  .introduce {
    width: 100%;
    height: 1150px;
    background: #e7f2ff;

    .introducetext {
      width: 100%;
      height: 1150px;
      background: #ffffff;
      border-radius: 10px;
      padding-top: 28px;
      padding-left: 53px;
      padding-right: 53px;

      hr {
        background: red;
      }

      h3 {
        font-size: 40px;
        color: #1d2754;
        line-height: 112px;
        text-align: center;
      }

      .text1 {
        margin-top: 8px;
        font-size: 24px;
        color: #1d2754;
        line-height: 50px;
        text-indent: 2em;
        text-align: justify;
      }

      .text2 {
        margin-top: 50px;
        font-size: 24px;
        color: #1d2754;
        line-height: 50px;
        text-indent: 2em;
        text-align: justify;
      }

      .text3 {
        margin: 50px 0;
        font-size: 24px;
        color: #1d2754;
        line-height: 50px;
        text-indent: 2em;
        text-align: justify;
      }
    }
  }

  .ontrial {
    width: 100%;
    height: 309px;
    background-image: url("https://images.36w.cn/ylyofficialWebImagse/bg_blue_01@2x.jpg");
    background-repeat: no-repeat;
    background-size: 105%;
    padding-top: 62px;

    h3 {
      font-size: 50px;
      color: #ffffff;
      line-height: 70px;
      text-align: center;
    }

    p {
      width: 158px;
      height: 66px;
      background: #ffffff;
      font-size: 24px;
      color: #0084ff;
      line-height: 66px;
      text-align: center;
      border-radius: 7px;
      margin: 0 auto;
      margin-top: 53px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/about/index.vue